<template>
  <div
    class="w-full max-w-sm mt-4 overflow-hidden rounded-md shadow-lg pointer-events-auto ring-1 ring-black/5 dark:ring-white/5 dark:shadow-white/5"
    :class="{
      'bg-red-50 dark:bg-red-900': notification.type == 'error',
      'bg-emerald-50 dark:bg-emerald-900': notification.type == 'success',
      'bg-amber-50 dark:bg-amber-900': notification.type == 'warning',
      'bg-gray-50 dark:bg-gray-900': notification.type == 'info',
    }"
  >
    <div class="p-4">
      <div class="flex items-start">
        <div class="shrink-0">
          <svg
            v-if="notification.type == 'error'"
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6 text-red-400"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
          >
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <svg
            v-if="notification.type == 'success'"
            class="w-6 h-6 text-emerald-400"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            aria-hidden="true"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
          <svg
            v-if="notification.type == 'warning'"
            class="w-6 h-6 text-amber-400"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            aria-hidden="true"
          >
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <svg
            v-if="notification.type == 'info'"
            class="w-6 h-6 text-gray-400"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            aria-hidden="true"
          >
            <path stroke-linecap="round" stroke-linejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
          </svg>
        </div>
        <div
          :class="{
            'text-red-700 dark:text-red-300': notification.type == 'error',
            'text-emerald-700 dark:text-emerald-300': notification.type == 'success',
            'text-amber-700 dark:text-amber-300': notification.type == 'warning',
            'text-gray-700 dark:text-gray-300': notification.type == 'info',
          }"
          class="ml-3 w-0 flex-1 pt-0.5"
        >
          <p class="text-sm font-medium">
            {{ notification.title }}
          </p>
          <p class="mt-1 text-sm opacity-80">
            {{ notification.text }}
          </p>
        </div>
        <div class="flex ml-4 shrink-0">
          <button
            class="inline-flex opacity-70 rounded-md hover:opacity-50 focus:outline-none focus:ring-2 relative -top-1 -right-1"
            :class="{
              'text-gray-400 hover:text-gray-500 focus:ring-gray-500': notification.type == 'info',
              'text-emerald-400 hover:text-emerald-500 focus:ring-emerald-500': notification.type == 'success',
              'text-amber-400 hover:text-amber-500 focus:ring-amber-500': notification.type == 'warning',
              'text-red-400 hover:text-red-500 focus:ring-red-500': notification.type == 'error',
            }"
            @click="$emit('close')"
          >
            <span class="sr-only">Close</span>
            <svg
              class="w-5 h-5"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            >
              <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  notification: {
    type: Object,
    default: () => {}
  }
});

const emit = defineEmits([ 'close', 'added' ]);
emit('added', props.notification.id);
</script>
